import React from 'react';

function UnsubscribeLeadEmail({ size }) {
  return (
    <p className={`unsubscribe-${size}-lead`}>Thanks, but I prefer my<br />email nonexistent</p>
  );
}

export default UnsubscribeLeadEmail;
